export default __webpack_public_path__ + "static/CapacityBuilding680x680-2902118a782431b9a32a905bd0acab8f.png";